import type { Member, MemberListResponse } from "../userService";

const FLAT_COLUMNS = [
  "_id",
  "id_client",
  "nama_lengkap",
  "no_hp",
  "email",
  "callsign",
  "tanggal_terbit",
  "masa_laku",
  "masa_laku_kta",
  "provinsi",
  "kabupaten",
  "status_callsign",
  "status_keanggotaan",
  "isSilentKey",
  "silentKeyReportedBy",
  "silentKeyReportedAt",
  "silentKeyNotes",
  "lastLoginAt",
  "lastSeenAt",
] as const;

export interface FlatMembersResponse {
  c: Record<string, string>;
  d: any[][];
  n: number;
  p: {
    nextCursor: string | null;
    previousCursor: string | null;
    hasNext: boolean;
    hasPrevious: boolean;
  };
}

export function parseFlatMembers(flat: FlatMembersResponse): MemberListResponse {
  const data: Member[] = flat.d.map((row) => {
    const obj: Record<string, any> = {};
    FLAT_COLUMNS.forEach((key, i) => {
      obj[key] = row[i] ?? null;
    });
    return obj as Member;
  });

  return {
    data,
    nextCursor: flat.p.nextCursor,
    previousCursor: flat.p.previousCursor,
    hasNext: flat.p.hasNext,
    hasPrevious: flat.p.hasPrevious,
  };
}
